import { motion } from "framer-motion";
import { Reveal, Label } from "./Motion";
import { ESSENCE } from "../data";

export const Essence = ({ onGift }) => (
  <section id="essence" data-testid="essence" className="relative py-24 md:py-36 bg-[#332e29] text-[#F7F5F0] pc-grain overflow-hidden">
    <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
        <Reveal>
          <span className="inline-flex items-center gap-3 rounded-full border border-[#5a5147] px-5 py-2">
            <span className="h-1.5 w-1.5 rounded-full bg-[#E8942E]" />
            <span className="uppercase tracking-[0.28em] text-[11px] font-semibold text-[#d8b487]">
              {ESSENCE.edition} &middot; Limited Release
            </span>
          </span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-7 font-serif text-4xl sm:text-5xl lg:text-7xl leading-[1.0]">
            {ESSENCE.title}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-[#c8beb4] leading-relaxed max-w-2xl mx-auto">{ESSENCE.intro}</p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
        {ESSENCE.tiers.map((t, i) => (
          <Reveal key={t.id} delay={i * 0.1}>
            <motion.div
              data-testid={`essence-${t.id}`}
              whileHover="hover"
              className={`group relative flex flex-col h-full border transition-colors duration-500 ${
                i === 2 ? "border-[#c9a06f]/60 bg-[#3d372f]" : "border-[#4a453f] bg-[#39332d]"
              }`}
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <motion.img
                  src={t.img} alt={t.name}
                  variants={{ hover: { scale: 1.05 } }}
                  transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                  className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#332e29] via-transparent to-transparent" />
                <span className="absolute top-4 right-5 font-serif text-5xl text-[#F7F5F0]/25 select-none">{t.no}</span>
                {i === 2 && (
                  <span className="absolute top-4 left-4 rounded-full bg-[#E8942E] text-[#2c2826] px-3 py-1 text-[10px] uppercase tracking-[0.2em] font-semibold">
                    Flagship
                  </span>
                )}
              </div>

              <div className="flex flex-col flex-1 p-6 md:p-7">
                <Label className="text-[#d8b487]">{t.level}</Label>
                <h3 className="mt-2 font-serif text-3xl text-[#F7F5F0]">{t.name}</h3>
                <p className="mt-3 text-sm text-[#c8beb4] leading-relaxed">{t.desc}</p>

                <ul className="mt-5 space-y-2 flex-1">
                  {t.items.map((it) => (
                    <li key={it} className="flex items-center gap-2.5 text-sm text-[#e7ddcf]">
                      <span className="h-1 w-1 rounded-full bg-[#E8942E]" />{it}
                    </li>
                  ))}
                </ul>

                <button
                  data-testid={`essence-gift-${t.id}`}
                  onClick={() => onGift(t)}
                  className={`mt-7 w-full rounded-full py-3.5 text-sm transition-colors duration-300 ${
                    i === 2
                      ? "bg-[#E8942E] text-[#2c2826] hover:bg-[#F7F5F0]"
                      : "border border-[#6b655d] text-[#F7F5F0] hover:bg-[#F7F5F0] hover:text-[#2c2826] hover:border-[#F7F5F0]"
                  }`}
                >
                  Enquire to gift &rarr;
                </button>
              </div>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
